import { fmtDate } from '../engine/format';
import { t } from '../engine/i18n';
import type { GameState } from '../engine/state';
import { GAME_VERSION } from '../engine/version';
import { update } from '../engine/store';
import {
  FAST_FORWARD_SPEED,
  PROLOGUE_SPEED,
  ageOnDay,
  dateAtDay,
  daysUntilNextMonth,
  hourOfDay,
} from '../engine/time';
import { canFastForward, isRunning, lifeCanAdvance, setFastForward } from '../game/sim';
import { STAGE_LABEL, formatDuration } from './labels';

export function Header({ state }: { state: GameState }) {
  const running = isRunning(state);
  const inPrologueYears = state.stage === 'prologue' && state.prologueStep === 'years';
  const speed =
    state.speed.dev *
    (inPrologueYears ? PROLOGUE_SPEED : 1) *
    (state.speed.fastForward ? FAST_FORWARD_SPEED : 1);

  return (
    <header class="header">
      <div class="brand">
        <h1>{t('app.title')}</h1>
        <span class="provisional">
          {t('app.provisional')} · {GAME_VERSION}
        </span>
      </div>
      {state.name && (
        <div class="identity">
          <strong>
            {t('header.identity', { name: state.name, age: ageOnDay(state.birthDate, state.startDate, state.day) })}
          </strong>
          <span>{fmtDate(dateAtDay(state.startDate, state.day))}</span>
          <span class="clock">{t('header.hour', { hour: hourOfDay(state.day) })}</span>
          <span class="stage-label">{t(STAGE_LABEL[state.stage])}</span>
          {lifeCanAdvance(state) && (
            <span class="month-end">
              {t('header.monthEnd', { days: Math.ceil(daysUntilNextMonth(state.startDate, state.day)) })}
            </span>
          )}
        </div>
      )}
      <div class="status">
        <span class={`badge ${running ? 'badge-running' : ''}`}>
          {running ? t('header.running') : t('header.paused')}
        </span>
        {running && speed !== 1 && <span class="badge">{t('header.speed', { speed })}</span>}
        {canFastForward(state) && (
          <>
            <span class="reserve">{t('header.reserve', { duration: formatDuration(state.reserveDays) })}</span>
            <button
              class="button-small"
              onClick={() => update((s) => setFastForward(s, !s.speed.fastForward))}
            >
              {state.speed.fastForward ? t('header.normalSpeed') : t('header.fastForward')}
            </button>
          </>
        )}
      </div>
    </header>
  );
}
